/* global t */
// Help articles for company setup (Innstillinger) and bank. Merged into helpArticles() in help-articles.jsx.
// Screenshots use the PlummeDEMO business so no customer data is exposed.
window.PlummeHelpArticlePacks = (window.PlummeHelpArticlePacks || []).concat([() => ({
  firstSetup: { id: 'firstSetup', title: t('ha.firstSetup.title'), category: t('ha.cat.setup'), read: t('ha.read3'), route: 'innstillinger',
    keywords: t('ha.firstSetup.keywords'),
    lead: t('ha.firstSetup.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.firstSetup.company'), text: t('ha.firstSetup.companyText') },
    { t: 'tip', kind: 'info', title: t('ha.firstSetup.locked'), text: t('ha.firstSetup.lockedText') },
    { t: 'step', n: 2, title: t('ha.firstSetup.logo'), text: t('ha.firstSetup.logoText') },
    { t: 'step', n: 3, title: t('ha.firstSetup.vat'), text: t('ha.firstSetup.vatText') },
    { t: 'tip', kind: 'info', title: t('ha.firstSetup.vatRegistration'), text: t('ha.firstSetup.vatRegistrationText') },
    { t: 'para', text: t('ha.firstSetup.vatSourceText') },
    { t: 'figure', src: 'src/img/help/firstSetup-vat.png', caption: t('ha.firstSetup.vat') },
    { t: 'step', n: 4, title: t('ha.firstSetup.opening'), text: t('ha.firstSetup.openingText') },
    { t: 'step', n: 5, title: t('ha.firstSetup.bank'), text: t('ha.firstSetup.bankText') },
    { t: 'tip', kind: 'tip', title: t('ha.firstSetup.inbox'), text: t('ha.firstSetup.inboxText') }]
  },
  bankAccount: { id: 'bankAccount', title: t('ha.bankAccount.title'), category: t('ha.cat.bank'), read: t('ha.read3'), route: 'innstillinger',
    keywords: t('ha.bankAccount.keywords'),
    lead: t('ha.bankAccount.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.bankAccount.add'), text: t('ha.bankAccount.addText') },
    { t: 'step', n: 2, title: t('ha.bankAccount.options'), text: t('ha.bankAccount.optionsText') },
    { t: 'step', n: 3, title: t('ha.bankAccount.opening'), text: t('ha.bankAccount.openingText') },
    { t: 'tip', kind: 'warn', title: t('ha.bankAccount.counter'), text: t('ha.bankAccount.counterText') },
    { t: 'step', n: 4, title: t('ha.bankAccount.reconcile'), text: t('ha.bankAccount.reconcileText') }]
  },
  bankReconcile: { id: 'bankReconcile', title: t('ha.bankReconcile.title'), category: t('ha.cat.bank'), read: t('ha.read3'), route: 'bank',
    keywords: t('ha.bankReconcile.keywords'),
    lead: t('ha.bankReconcile.lead'),
    blocks: [
    { t: 'heading', text: t('ha.h6.before') },
    { t: 'para', text: t('ha.bankReconcile.beforeText') },
    { t: 'step', n: 1, title: t('ha.bankReconcile.upload'), text: t('ha.bankReconcile.uploadText') },
    { t: 'figure', src: 'src/img/help/bankReconcile-upload.png', caption: t('ha.bankReconcile.upload') },
    { t: 'tip', kind: 'info', title: t('ha.bankReconcile.noConnection'), text: t('ha.bankReconcile.noConnectionText') },
    { t: 'step', n: 2, title: t('ha.bankReconcile.balances'), text: t('ha.bankReconcile.balancesText') },
    { t: 'step', n: 3, title: t('ha.bankReconcile.approve'), text: t('ha.bankReconcile.approveText') },
    { t: 'step', n: 4, title: t('ha.bankReconcile.rest'), text: t('ha.bankReconcile.restText') },
    { t: 'step', n: 5, title: t('ha.bankReconcile.receipts'), text: t('ha.bankReconcile.receiptsText') },
    { t: 'step', n: 6, title: t('ha.bankReconcile.finish'), text: t('ha.bankReconcile.finishText') },
    { t: 'tip', kind: 'warn', title: t('ha.bankReconcile.controls'), text: t('ha.bankReconcile.controlsText') }]
  },
  inviteAccountant: { id: 'inviteAccountant', title: t('ha.inviteAccountant.title'), category: t('ha.cat.setup'), read: t('ha.read2'), route: 'innstillinger',
    keywords: t('ha.inviteAccountant.keywords'),
    lead: t('ha.inviteAccountant.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.inviteAccountant.open'), text: t('ha.inviteAccountant.openText') },
    { t: 'step', n: 2, title: t('ha.inviteAccountant.role'), text: t('ha.inviteAccountant.roleText') },
    { t: 'step', n: 3, title: t('ha.inviteAccountant.manage'), text: t('ha.inviteAccountant.manageText') }]
  }
})]);
